export default __webpack_public_path__ + "static/media/ee3.0f80d19e.png";